// Mock data for Creative Sales Source LLC website
// All content is mock/local — replace with backend later

export const company = {
  name: "Creative Sales Source LLC",
  shortName: "Creative Sales Source",
  tagline: "The Trusted Connection Between Building Manufacturers and Dealers",
  established: 2012,
  logo: "https://img1.wsimg.com/isteam/ip/c1424f40-27ce-48a2-ab80-93ceb931a417/New%20Logo.jpg/:/rs=h:120,cg:true,m/qt=q:90",
  email: "info@creativesalessource.com",
  phone: "847-354-0754",
  address: "Chicago, Illinois — Serving the Midwest",
  hours: "Mon – Fri · 9:00 am – 5:00 pm ET",
  socials: {
    facebook: "https://www.facebook.com/salessourcess/",
    instagram: "https://www.instagram.com/creativesalessource/",
    linkedin: "https://www.linkedin.com/company/creative-sales-source/",
    x: "https://www.x.com/salessourcellc",
  },
};

export const heroImages = [
  "/uploads/lumber-semi.webp",
  "/uploads/warehouse.webp",
  "https://images.unsplash.com/photo-1553413077-190dd305871c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwzfHx3YXJlaG91c2V8ZW58MHx8fHwxNzgwNjY2NjkxfDA&ixlib=rb-4.1.0&q=85&w=1600",
];

export const aboutImage = "/uploads/about-handshake.webp";

export const newsletterImage =
  "https://images.pexels.com/photos/5860937/pexels-photo-5860937.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const valuePillars = [
  {
    number: "01",
    title: "Deep-Rooted Territory Intelligence",
    body:
      "We don't rely on cold calls and generic lists. We leverage decades of established, high-trust relationships with the Midwest's most influential distributors and contractors. We know the decision-makers by name — and exactly how to position your products to win their business.",
  },
  {
    number: "02",
    title: "Transparent, Data-Driven Performance",
    body:
      "Stop wondering what's happening in the field. We provide consistent, transparent reporting that tracks every sales call, lead conversion, and market trend — giving you the visibility of an in-house team with the agility of a specialized agency.",
  },
  {
    number: "03",
    title: "Strategic Brand Stewardship",
    body:
      "Your brand reputation is your most valuable asset. Our team undergoes rigorous product training to ensure we represent your technical specs, value proposition, and company culture with the same passion and precision as your own internal sales force.",
  },
  {
    number: "04",
    title: "Accelerated Speed-to-Market",
    body:
      "Why build a regional sales infrastructure from scratch? We provide an immediate \u201cplug-and-play\u201d solution, letting you hit the ground running with a veteran team already embedded in the market.",
  },
];

export const partners = [
  {
    name: "Woolf Distributing",
    url: "https://www.woolfdistributing.com/",
    domain: "woolfdistributing.com",
    blurb: "Independent building materials distributor serving the Midwest since 1936.",
  },
  {
    name: "Midamerica Building Supply",
    url: "https://midambuildingsupply.com/",
    domain: "midambuildingsupply.com",
    blurb: "Full-line distributor of doors, windows, and millwork across the central US.",
  },
  {
    name: "BPI — Building Products Inc.",
    url: "https://bpi.build/",
    domain: "bpi.build",
    blurb: "Wholesale building products distribution with a regional logistics network.",
  },
  {
    name: "Lumbermen's",
    url: "https://www.lumbermens-inc.com/",
    domain: "lumbermens-inc.com",
    blurb: "Employee-owned distributor of specialty lumber and building materials.",
  },
  {
    name: "Lumber Loop USA",
    url: "https://lumberloopusa.com/",
    domain: "lumberloopusa.com",
    blurb: "National lumber sourcing & logistics platform connecting mills with dealers.",
  },
  {
    name: "Minot Builders Supply",
    url: "https://minotbuilderssupply.com/",
    domain: "minotbuilderssupply.com",
    blurb: "Trusted regional supplier of lumber, hardware, and building products across the Dakotas.",
  },
];

// State-level coverage data for the interactive US map.
// id = US FIPS state code (matches us-atlas TopoJSON ids)
export const coveredStates = {
  18: { name: "Indiana", distributors: 4, note: "Core territory — strong distributor density." },
  17: { name: "Illinois", distributors: 3, note: "HQ state — Chicago, Rockford, Peoria coverage." },
  55: { name: "Wisconsin", distributors: 2, note: "Pro-dealer focus, growing line presence." },
  27: { name: "Minnesota", distributors: 3, note: "Twin Cities + outstate distribution." },
  19: { name: "Iowa", distributors: 2, note: "Independent yard network, central IA hub." },
  31: { name: "Nebraska", distributors: 1, note: "Lincoln & Omaha pro-dealer accounts." },
  38: { name: "North Dakota", distributors: 1, note: "Minot Builders Supply partnership." },
  46: { name: "South Dakota", distributors: 1, note: "Sioux Falls & Rapid City coverage." },
  30: { name: "Montana", distributors: 1, note: "Western expansion territory." },
};

export const territories = [
  "Indiana",
  "Illinois",
  "Wisconsin",
  "Minnesota",
  "Iowa",
  "Nebraska",
  "North Dakota",
  "South Dakota",
  "Montana",
];

export const team = [
  {
    name: "Jeff Mitchell",
    role: "Founder & Principal",
    bio:
      "30+ years in building materials distribution. Built Creative Sales Source to bridge manufacturers and the Midwest's strongest distributor networks.",
    initials: "JM",
  },
  {
    name: "Sarah Henderson",
    role: "Director of Territory Sales",
    bio:
      "Former regional sales manager with deep relationships across IN, OH, and KY. Specializes in lumber and exterior products.",
    initials: "SH",
  },
  {
    name: "Mark Daniels",
    role: "Northern Region Lead",
    bio:
      "Covers WI, MN, MI and the Dakotas. 18 years calling on independent yards and pro-dealer chains.",
    initials: "MD",
  },
  {
    name: "Lisa Brooks",
    role: "Operations & Reporting",
    bio:
      "Keeps the CRM honest. Builds the dashboards our principals rely on for weekly visibility into the field.",
    initials: "LB",
  },
];

export const milestones = [
  { year: "2012", title: "Founded in Chicago", body: "Started as a two-person rep agency covering Illinois, Indiana, and Wisconsin — onboarded our first national manufacturer." },
  { year: "2015", title: "Expanded into Iowa & Minnesota", body: "Added two veteran territory managers and onboarded our 3rd national manufacturer." },
  { year: "2019", title: "Grew our Distribution Partners from 2 to 4", body: "Added Lumbermen's and MidAm to our growth portfolio." },
  { year: "2022", title: "Northern Coverage Added", body: "Welcomed coverage across Nebraska, North & South Dakota, as well as Montana — now serving 9 states." },
  { year: "2026", title: "A Decade-Plus of Partnership", body: "Celebrating 14+ years of growing market share for the manufacturers who trust us." },
];

export const services = [
  {
    title: "Manufacturer Representation",
    body: "Full-service outsourced sales force calling on distributors, dealers, and large contractors across the Midwest.",
  },
  {
    title: "Market Intelligence",
    body: "On-the-ground feedback about pricing, competitors, product gaps, and where your line wins or loses.",
  },
  {
    title: "Product Training",
    body: "We host counter days, ride-alongs, and training sessions so the people quoting your product actually understand it.",
  },
  {
    title: "Trade Show Support",
    body: "Booth coverage and lead follow-up at regional KBIS, IBS, and dealer-association shows.",
  },
  {
    title: "Forecasting & Reporting",
    body: "Reporting, reviews, and quarterly forecasts — we keep you updated on your products' performance in our market(s).",
  },
  {
    title: "New Product Launches",
    body: "Pre-launch territory mapping, distributor stocking commitments, and the first 90 days of in-market push.",
  },
];

export const testimonials = [
  {
    quote:
      "Creative Sales Source opened doors for us that we'd been knocking on for years. Within 18 months they doubled our Midwest revenue and our distributors actually pick up the phone when they call.",
    author: "Michael C.",
    title: "VP of Sales",
    company: "National Siding Manufacturer",
    initials: "MC",
    rating: 5,
  },
  {
    quote:
      "Their reporting is the most honest we've ever received from a rep group. We always know where we stand in the field — no fluff, no surprises, just the numbers and what's behind them.",
    author: "Jennifer W.",
    title: "Director of Marketing",
    company: "Engineered Wood Products Co.",
    initials: "JW",
    rating: 5,
  },
  {
    quote:
      "They treat our brand like it's their own. Product knowledge, relationships, follow-through — everything you want in a rep partner. Two years in and we're expanding our agreement.",
    author: "Robert H.",
    title: "President",
    company: "Specialty Fasteners Manufacturer",
    initials: "RH",
    rating: 5,
  },
  {
    quote:
      "I've worked with five different rep agencies over my career. Creative Sales Source is the only one that brought me a stocking commitment in the first 90 days. They know the Midwest like nobody else.",
    author: "Sarah L.",
    title: "National Sales Manager",
    company: "Exterior Building Products",
    initials: "SL",
    rating: 5,
  },
];
